import styled from "@emotion/styled"
import { css } from '@emotion/react'
import facepaint from "facepaint"

const breakpoints = [440, 768, 1024, 1200, 1400]
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))

const topLine = ({ isTopLine }) => {
  if (isTopLine) {
    return css({
      '&:before': {
        content: "''",
        position: 'absolute',
        width: '1px',
        height: '140px',
        top: '-172px',
        left: 'calc(50% - 0.5px)',
        background: 'linear-gradient(0deg, #D5D5D5 34.1%, #FFF 100%)',
      }
    })
  }
}

const wrapMQ = css(mq({
  maxWidth: [
    "calc(100vw - 32px)", // 0+
    "calc(100vw - 32px)", // 440+
    "calc(100vw - 64px)", // 768+
    "calc(100vw - 80px)", // 1024+
  ],
  gridTemplateRows: [
    "48px 1fr", // 0+
    "48px 1fr", // 440+
    "64px 1fr", // 768+
    "64px 1fr", // 1024+
    "64px 1fr", // 1200+
    "none", // 1400+
  ],
  gridTemplateColumns: [
    "none", // 0+
    "none", // 440+
    "none", // 768+
    "none", // 1024+
    "none", // 1200+
    "64px 1fr 64px", // 1400+
  ],
  gap: [
    24, // 0+
    24, // 440+
    24, // 768+
    24, // 1024+
    24, // 1200+
    60, // 1400+
  ],
}))

export const Wrap = styled.div`
  display: grid;
  width: 1510px;
  margin: 0 auto;
  ${wrapMQ}
`

const leftColumnMQ = css(mq({
  "&:after, &:before": {
    display: [
      "none", // 0+
      "none", // 440+
      "none", // 768+
      "none", // 1024+
      "none", // 1200+
      "block", // 1400+
    ],
  }
}))

export const LeftColumn = styled.div`
  position: relative;

  &:after {
    content: '';
    position: absolute;
    width: 1px;
    height: 240px;
    top: 106px;
    left: calc(50% - 0.5px);
    background: linear-gradient(180deg, #D5D5D5 34.1%, #FFF 100%);
  }
  ${topLine}
  ${leftColumnMQ}
`

const rightColumnMQ = css(mq({
  display: [
    "none", // 0+
    "none", // 440+
    "none", // 768+
    "none", // 1024+
    "none", // 1200+
    "block", // 1400+
  ],
}))

export const RightColumn = styled.div`
  ${rightColumnMQ}
`
